import React from 'react'

import { ProjectRoot } from 'features/project/components/project-root/ProjectRoot'
import { useProjectService } from 'features/project/service'

type Props = { projectId: string }

export const Root: React.FC<Props> = React.memo(function Root({ projectId }) {
  const projectService = useProjectService()

  return <ProjectRoot projectId={projectId} projectService={projectService} />
})
